import { useChatColors } from '@/contexts/ChatColorsContext';

interface ChatHeaderProps {
  onClose: () => void;
}

export default function ChatHeader({ onClose }: ChatHeaderProps) {
  const { primary } = useChatColors();

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-white border-b border-gray-100 flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 flex items-center justify-center overflow-hidden rounded-full bg-gray-50 border border-gray-100">
          <img
            src="https://static.readdy.ai/image/22602f61db723d886df2ffcff534fda8/4728923fdc166275b7926e4817bf6e64.png"
            alt="Bozzetti Store"
            className="w-full h-full object-contain"
          />
        </div>

        <div>
          <p
            className="text-sm font-bold text-gray-800"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Bozzetti Store
          </p>

          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
            <span className="text-xs text-gray-500">Online agora</span>
          </div>
        </div>
      </div>

      {/* BOTÃO FECHAR (ÚNICO) */}
      <button
        type="button"
        onClick={onClose}
        className="w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 transition-colors cursor-pointer"
      >
        <i className="ri-close-line text-lg" />
      </button>
    </div>
  );
}